import React,{useRef,useEffect} from 'react';    
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import LazyLoad from 'react-lazy-load';
function ScreenshotPage(props)
{
    var images = ["CastleInterior2","Ravine1","Sewers","Town1","Waterfall1","Volcanoe1","Flames1","BlackCastle1"]
    return <div><Carousel showArrows={true}>
            {images.map(image=>(<div key={image}>
                                    <img src={"/images/"+ image + ".png"}/>
                                </div>))} 
        </Carousel>
        <LazyLoad  height={700}><div></div></LazyLoad> 
        </div>

}

export default ScreenshotPage